/**
 * Get the organization slug from the URL subdomain.
 * - Production: acme.app.fakto.ai -> acme
 * - Local: test-org.localhost:3000 -> test-org
 */
export function getOrgSlug(): string {
  return window.location.hostname.split('.')[0];
}
